module.exports = __webpack_public_path__ + "img/logo-vinaphone.8168c445.png";